export const analyticsId = {
  BROKER_STOCK_BUY_STEP_1_VIEW: 'BROKER_STOCK_BUY_STEP_1_VIEW',
  BROKER_STOCK_BUY_STEP_2_VIEW: 'BROKER_STOCK_BUY_STEP_2_VIEW',
  BROKER_STOCK_BUY_STEP_1_SUCCESS: 'BROKER_STOCK_BUY_STEP_1_SUCCESS',
  BROKER_STOCK_BUY_STEP_2_SUCCESS: 'BROKER_STOCK_BUY_STEP_2_SUCCESS',
  BROKER_STOCK_BUY_ERROR: 'BROKER_STOCK_BUY_ERROR',
  BROKER_STOCK_BUY_SUCCESS: 'BROKER_STOCK_BUY_SUCCESS',
};

const commonFields = productName => ({
  sectionFamily: 'wealth',
  sectionCategory: 'products',
  sectionName: 'stocks',
  serviceType: 'productContracting',
  interactionType: 'funnel',
  processType: 'buyStocks',
  productName,
});

export const catalogue = {
  [analyticsId.BROKER_STOCK_BUY_STEP_1_VIEW]: ({ productName }) => ({
    ...commonFields(productName),
    event_name: 'step_investment_details',
    pageName: '/buyStocks/step1/investmentDetails',
    processStep: 'step1',
    processDetail: 'investmentDetails',
  }),
  [analyticsId.BROKER_STOCK_BUY_STEP_2_VIEW]: ({ productName }) => ({
    ...commonFields(productName),
    event_name: 'step_terms_conditions',
    pageName: '/buyStocks/step2/termsConditions',
    processStep: 'step2',
    processDetail: 'termsConditions',
  }),
  [analyticsId.BROKER_STOCK_BUY_STEP_1_SUCCESS]: () => ({
    event_name: 'event_success',
    action: 'success',
    format: 'steps',
    component: 'funnel',
    element: 'investmentDetails',
    data: 'next',
  }),
  [analyticsId.BROKER_STOCK_BUY_STEP_2_SUCCESS]: () => ({
    event_name: 'event_success',
    action: 'success',
    format: 'steps',
    component: 'funnel',
    element: 'termsConditions',
    data: 'next',
  }),
  [analyticsId.BROKER_STOCK_BUY_ERROR]: ({ productName, errorMessage }) => ({
    ...commonFields(productName),
    event_name: 'step_error',
    pageName: '/buyStocks/error/genericError',
    processStep: 'error',
    processDetail: 'genericError',
    errorCategory: 'genericError',
    errorDescription: errorMessage,
  }),
  [analyticsId.BROKER_STOCK_BUY_SUCCESS]: ({ productName }) => ({
    ...commonFields(productName),
    event_name: 'step_success',
    pageName: '/buyStocks/success',
    processStep: 'success',
  }),
};
